var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SectionCard',{attrs:{"label":"История изменения"}},[_c('TimeLine',{attrs:{"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }